module.exports = __webpack_public_path__ + "static/media/Football.da81a72a.jpg";